const LS_USER_KEY = 'user';

export { LS_USER_KEY };
